export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const ALLOWED_FILE_TYPES = {
    // PDF files
    'application/pdf': '.pdf',
    // Word documents
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    // Text files
    'text/plain': '.txt',
} as const;

// Allowed file extensions for fallback validation
const ALLOWED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.txt'];

export const isAllowedFileType = (file: File): boolean => {
    // First, check by MIME type
    const mimeTypeMatch = Object.keys(ALLOWED_FILE_TYPES).some(type => file.type === type);
    if (mimeTypeMatch) return true;
    
    // Fallback: Check by file extension
    // This is needed because Windows browsers often report .md files as:
    // - empty string ""
    // - "application/octet-stream"  
    // - "text/plain"
    // instead of "text/markdown"
    const fileName = file.name.toLowerCase();
    return ALLOWED_EXTENSIONS.some(ext => fileName.endsWith(ext));
};
